import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  pointerCircle: {
    borderRadius: '6px',
    boxShadow: 'inset 0 0 0 1px #ffffff',
    height: '12px',
    transform: 'translate(-6px, -6px)',
    width: '12px',
  },
});
